import React from 'react';
import Console from '../../../lib/debug';
import Drop from '../../designer/components/Drop';

const ChipDrop = props => {
    Console.render('ChipDrop');
    return (
        <div className="th-chip-drop">
            <label>{props.label}</label>
            <Drop
                name={props.name}
                value={props.value}
                multi={props.multi}
                options={props.options}
                labelKey={props.labelKey}
                valueKey={props.valueKey}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onNewOptionClick={props.onNewOptionClick}
                hasError={props.hasError}
                errorMessage={props.errorMessage}
            />
        </div>
    );
};

export default ChipDrop;
